import moment from "moment";
export const MAX_SEARCH_WITHIN = 7 * 24 * 60 * 60 * 1e3;
export const MIN_EXECUTE_EVERY = 5 * 60 * 1e3;
export const SEARCH_WITHIN_UNITS = ["HOURS", "MINUTES", "DAYS"];
export const EXECUTE_EVERY_UNITS = ["HOURS", "MINUTES"];
export const INITIAL_RULE_OPTIONS = {
  source: "",
  search_within: 5,
  search_within_unit: "MINUTES",
  execute_every: 5,
  execute_every_unit: "MINUTES",
  use_cron_scheduling: false,
  cron_expression: "",
  cron_timezone: "",
  streams: [],
  stream_categories: [],
  notifications: [],
  filters: [],
  remediation_steps: "",
  event_procedure_id: "",
  event_summary_template: null
};
const validateSearchWithin = (time, unit) => {
  const auxTime = moment.duration(time, unit).asMilliseconds();
  if (auxTime > MAX_SEARCH_WITHIN) return "Max value is 7 DAYS";
  if (auxTime < 0) return "Invalid negative value";
  return null;
};
const validateExecuteEvery = (time, unit) => {
  const auxTime = moment.duration(time, unit).asMilliseconds();
  if (auxTime < MIN_EXECUTE_EVERY) return "Minimum value is 5 MINUTES";
  return null;
};
export const validate = (values) => {
  const errors = {};
  const searchWithinError = validateSearchWithin(values.search_within, values.search_within_unit);
  const executeEveryError = validateExecuteEvery(values.execute_every, values.execute_every_unit);
  if (searchWithinError) errors.search_within = searchWithinError;
  if (executeEveryError) errors.execute_every = executeEveryError;
  return errors;
};
export const formOptionsToPayload = (formRule) => {
  var _a;
  const toMilliseconds = (time, unit) => {
    let milliseconds = time * 1e3;
    if (unit === "MINUTES" || unit === "HOURS" || unit === "DAYS") milliseconds *= 60;
    if (unit === "HOURS" || unit === "DAYS") milliseconds *= 60;
    if (unit === "DAYS") milliseconds *= 24;
    return milliseconds;
  };
  return {
    search_within_ms: toMilliseconds(formRule.search_within, formRule.search_within_unit),
    execute_every_ms: toMilliseconds(formRule.execute_every, formRule.execute_every_unit),
    use_cron_scheduling: formRule.use_cron_scheduling,
    cron_expression: formRule.cron_expression,
    cron_timezone: formRule.cron_timezone,
    streams: formRule.streams,
    stream_categories: formRule.stream_categories,
    notifications: formRule.notifications,
    filters: formRule.filters,
    remediation_steps: formRule.remediation_steps,
    event_procedure_id: formRule.event_procedure_id,
    event_summary_template: (_a = formRule.event_summary_template) != null ? _a : null,
    share_request: formRule.share_request
  };
};
